import { NavLink } from "react-router-dom";

import { useAuthStore } from "@/store/authStore";

const NAV_ITEMS = [
  { to: "/dashboard", label: "Dashboard", permission: "dashboard.view" },
  { to: "/users", label: "Users", permission: "users.view" },
  { to: "/sessions", label: "Sessions", permission: "sessions.view" },
  { to: "/devices", label: "Devices", permission: "devices.view" },
  { to: "/nas", label: "NAS / APs", permission: "dashboard.view" },
  { to: "/reports", label: "Reports", permission: "reports.view" },
  { to: "/logs", label: "Logs", permission: "logs.view" },
  { to: "/settings", label: "Settings", permission: "dashboard.view" },
  { to: "/audit", label: "Audit log", permission: "audit.view" },
  // Grafana intentionally not linked here — page/route still exist
  // (/grafana), just not in the nav. Never set up on this deployment; add
  // back with { to: "/grafana", label: "Grafana", permission: "dashboard.view" }
  // whenever that changes.
];

export function Sidebar() {
  const hasPermission = useAuthStore((s) => s.hasPermission);

  return (
    <aside className="flex w-56 shrink-0 flex-col gap-1 border-r border-border bg-surface p-4">
      <div className="mb-4 px-2">
        <p className="font-mono text-xs uppercase tracking-wide text-accent">radadmin</p>
        <p className="text-xs text-text-muted">deutschlandbvik.com</p>
      </div>
      <nav className="flex flex-col gap-0.5">
        {NAV_ITEMS.filter((item) => hasPermission(item.permission)).map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `rounded-md px-3 py-2 text-sm transition-colors ${
                isActive
                  ? "bg-surface-2 text-text"
                  : "text-text-muted hover:bg-surface-2 hover:text-text"
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
